<div class="date-container">

    <div class="select">
        <div class="select_option" *ngFor="let avalableDateLabel of avalableDateLabels" (click)="selectLabel(avalableDateLabel)"
            [ngClass]="{'select_option--selected': selectedDateLabel === avalableDateLabel}">{{avalableDateLabel}}</div>

        <div class="select_option" [ngClass]="{'select_option--selected': selectedDateLabel === 'custom'}">Custom</div>
    </div>

    <div class="custom">
        <mat-calendar #calendar [selected]="selectedRangeValue" [startAt]="startAt" (selectedChange)="selectedChange($event)" [maxDate]="today">
        </mat-calendar>
    </div>

</div>

<div class="filter-footer">
    <app-button [buttonSize]="'action'" [buttonStyle]="'underline'" (click)="reset()" *ngIf="!dialogData.hideResetbtn">Reset</app-button>
    <app-button [buttonSize]="'action'" [spin]="spin" (click)="save()">Save</app-button>
  </div>